import {Redirect, Route} from "react-router";
import React from "react";
import {AuthContext} from "../contexts/auth";

function ProtectedRoute({children, ...restOfProps}) {
    const [state] = React.useContext(AuthContext)

    return (
        <Route
            {...restOfProps}
            render={() =>
                state.auth ? children : <Redirect to="/login"/>
            }
        />
    );
}

export default ProtectedRoute;